import { Gestacao } from 'graphql/types.generated'
import moment, { Moment } from 'moment'

export function calculateIdadeGestacional(
  gestacoesPeriodo: Gestacao[],
  data: Moment = moment()
): { idadeGestacional: number; hasGestacaoPeriodo: boolean } {
  const gestacao = gestacoesPeriodo.find((g) =>
    /**
     * granularity?: null //void - not to affect the comparison between dates
     * inclusivity?: '[]' //fully inclusive - to include the 42nd week fully
     */
    data.isBetween(moment(g.inicio), g.fim ? moment(g.fim) : moment(g.inicio).add(42, 'w'), null, '[]')
  )
  return { idadeGestacional: Math.floor(data.diff(moment(gestacao?.inicio), 'w')), hasGestacaoPeriodo: !!gestacao }
}
